import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../services/AuthService';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const isAdminPrefixed = location.pathname.startsWith('/admin');
  const loginPath = isAdminPrefixed ? '/admin/login' : '/login';
  const dashboardPath = isAdminPrefixed ? '/admin/dashboard' : '/dashboard';
  const motoboyPath = isAdminPrefixed ? '/admin/motoboy/dashboard' : '/motoboy/dashboard';
  const isRouteInSegment = (path, segment) =>
    path === segment || path.startsWith(`${segment}/`);

  const isMotoboyArea =
    isRouteInSegment(location.pathname, '/motoboy') ||
    isRouteInSegment(location.pathname, '/admin/motoboy');

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to={loginPath} replace />;
  }

  if (user.user_type === 'motoboy') {
    if (!isMotoboyArea) {
      return <Navigate to={motoboyPath} replace />;
    }
    return children;
  }

  if (user.user_type !== 'motoboy' && isMotoboyArea) {
    return <Navigate to={dashboardPath} replace />;
  }

  if (!['admin_master', 'admin_lanchonete', 'cashier', 'kitchen', 'waiter'].includes(user.user_type)) {
    return <Navigate to={loginPath} replace />;
  }

  return children;
}

export default ProtectedRoute;
